import {FC, useState} from 'react'
import {KTSVG} from '../../../../../../../../../../../_metronic/helpers'
import {RelatedFiles} from '../../core/_models'
import {ModalEditRelatedFiles} from '../../modal/ModalEditRelatedFiles'

type Props = {
  RelatedFiles: RelatedFiles
}
const RelatedFilesActionsCell: FC<Props> = ({RelatedFiles}) => {
  const [showPropertiesRegisterModal, setPropertiesRegisterModal] = useState<boolean>(false)

  return (
    <div className='d-flex flex-line align-items-center'>
      {RelatedFiles.file && (
        <a
          href={RelatedFiles.file?.toString()}
          title='Download'
          target='_blank'
          rel='noreferrer'
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm
          bg-hover-light-primary mx-1'
        >
          <KTSVG path='/media/icons/duotune/files/fil017.svg' className='svg-icon-1' />
        </a>
      )}
      <button
        title='Editar'
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm
        bg-hover-light-warning mx-1'
        onClick={() => setPropertiesRegisterModal(true)}
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_edit_properties_registries'
      >
        <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-1' />
      </button>
      <ModalEditRelatedFiles
        id='propertiesRegistriesEdit'
        show={showPropertiesRegisterModal}
        handleClose={() => setPropertiesRegisterModal(false)}
        uuidRow={RelatedFiles.uuid}
      />
    </div>
  )
}

export {RelatedFilesActionsCell}
